import { get } from "../../api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LSNG_ADMIN_API_URL;

const getGenericFilterParams = (context) => {
  return get(`${url}/GenericFilter/genericFilterParams?context=${context}`);
};

const getGenericFilterOperators = () => {
  return get(`${url}/GenericFilter/genericFilterOperators`);
};

const getGenericFilterParamValues = paramId => {
  return get(`${url}/GenericFilter/genericFilterValues?ParamId=${paramId}`);
};

const getPagedGenericFilterParamValues = (paramId, name, page) => {
  return get(`${url}/GenericFilter/genericFilterValuesPaginated?ParamId=${paramId}&Name=${name??""}&Page=${page}`);
};

const exp = {
  getGenericFilterParams,
  getGenericFilterOperators,
  getGenericFilterParamValues,
  getPagedGenericFilterParamValues
};
export default exp;
